<template>
  <section class="grid-block">
    <header>
      <span>Договоры</span>
      <VButton
        theme="link"
        @click="createContract"
      >
        <template #icon>
          <VIcon material="add"/>
        </template>
        Добавить договор
      </VButton>
    </header>

    <div class="content">
      <VDataGridV2
        :loader="dataLoader"
        :context-menu="ContractsExternalService.contextMenu"
        layout="fill"
        @row:dblclick="openContract"
      >
        <VDataGridColumnV2
          id="id"
          label="№"
          width="15%"
        >
          <template #default="{ row }">
            <div>№ {{ row.number }}</div>
            <div class="nowrap description">
              от {{ $core.utils.date.format(row.validityPeriod.start) }}
            </div>
          </template>
        </VDataGridColumnV2>

        <VDataGridColumnV2
          id="seller"
          label="Поставщик"
          width="40%"
        >
          <template #default="{ row }">
            <div :title="row.sellerCompany.name">
              {{ row.sellerCompany.name }}
            </div>
          </template>
        </VDataGridColumnV2>

        <VDataGridColumnV2
          id="buyer"
          label="Покупатель"
          width="40%"
        >
          <template #default="{ row }">
            <div :title="row.buyerCompany.name">
              {{ row.buyerCompany.name }}
            </div>
          </template>
        </VDataGridColumnV2>
      </VDataGridV2>
    </div>
  </section>
</template>

<script lang="ts">

import Partner                  from '@/domains/Partners/Partner';
import ContractsExternalService from "@/domains/Contracts/ContractsExternalService";
import type ContractExternal   from "@/domains/Contracts/ContractExternal";

export default defineComponent({
  name: 'ContractsSection',

  props: {
    localPartner: {
      type:    Partner,
      default: null,
    },
  },

  emits: [
    'contracts:updated',
  ],

  data() {
    return {
      ContractsExternalService,

      /**
       * Договоры не входят в partners.get — грузятся отдельным запросом
       * (contracts.getListExternal по продавцу). Реактивный источник по партнёру:
       * смена localPartner сама триггерит перезагрузку, watch не нужен.
       */

      dataLoader: this.$core.loader.dataGrid(
        () => ContractsExternalService.getListPaginated({ seller: this.localPartner }),
      ),
    };
  },

  methods: {
    /** Реестр обновляем, только если договор сохранили (resolve карточки) */
    async createContract(): Promise<void> {
      if (await ContractsExternalService.createContract(this.localPartner) === true) {
        this.onContractsChanged();
      }
    },

    async openContract(contract: ContractExternal): Promise<void> {
      if (await ContractsExternalService.showContractCard(contract) === true) {
        this.onContractsChanged();
      }
    },

    onContractsChanged() {
      this.dataLoader.refresh();
      this.$emit('contracts:updated');
    },
  },
});
</script>
